<div class="text-dark p-2 d-flex align-items-center h-100 justify-content-center" >
    <div class="label center lead">{{model.name}}    &nbsp; <i class="{{model.icon}}"></i> </div>
</div>